import { apiClient } from "./apiClient";

const auth = (accessToken) => ({ headers: { Authorization: `Bearer ${accessToken}` } });

export const getTwoFactorStatus = (accessToken) =>
  apiClient.get("/auth/2fa/status", auth(accessToken)).then((res) => res.data);

export const startTwoFactorSetup = (accessToken) =>
  apiClient.post("/auth/2fa/setup", {}, auth(accessToken)).then((res) => res.data);

export const enableTwoFactor = (accessToken, code) =>
  apiClient.post("/auth/2fa/enable", { code }, auth(accessToken)).then((res) => res.data);

export const disableTwoFactor = (accessToken, password, code) =>
  apiClient.post("/auth/2fa/disable", { password, code }, auth(accessToken)).then((res) => res.data);
